import React, { ReactNode } from 'react';
import { Box, Stack, Text } from '@origin-digital/ods-core';
import { StaticPerkAccordionType } from '../../typings';

const BatteryLitePerkSummary: ReactNode = <Text weight="medium">Important info</Text>;

const BatteryLitePerkBody: React.ReactNode = (
  <Stack space="medium">
    <Box>
      <Text>
        This is an electricity plan and you must be connected to our Loop VPP. See Loop eligibility
        criteria and T&C’s below.
      </Text>
    </Box>
  </Stack>
);

export const BatteryLitePerk: StaticPerkAccordionType = {
  accordionIcon:
    'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_battery_wall.svg',
  accordionSummary: BatteryLitePerkSummary,
  accordionBody: BatteryLitePerkBody,
  accordionDataId: 'battery-lite-perk',
  expanded: true,
  synced: true,
};
